import { stringOrUndefined } from "@faire/retailer-visitor-shared/lib/stringOrUndefined";
import { useLocation } from "react-router-dom";
export var useProductTokenForUpdateCartModal = function() {
    var location = useLocation();
    var searchParams = new URLSearchParams(location.search);
    var product = searchParams.get("product");
    return stringOrUndefined(product);
};
